import { render, staticRenderFns } from "./OfflineCourse.vue?vue&type=template&id=7e989ac3&scoped=true"
import script from "./OfflineCourse.vue?vue&type=script&lang=ts"
export * from "./OfflineCourse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e989ac3",
  null
  
)

export default component.exports